module.exports = __webpack_public_path__ + "static/media/signed_icon.1f657a35.svg";